//	Internals
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import React, { memo, useState, useEffect } from "react";
import Datetime from "react-datetime";

import Select from "react-dropdown";
import MultiSelect from "react-select";
import { components } from "react-select";
//	Externals
//import { useNavigate } from "react-router-dom";
//import { MSG } from "../../../constants/MSG";
import CS from "../../../services/commonService";
import { useFormik } from "formik";
import { useStore } from "../../../zustand/store";

//import dataUrlToFile from "../../common/urlToFile";
import { couponsSchema } from "../../../validations/couponsValidations";
import { useupdateCoupons } from "../../../queryHooks/useCoupons";
import { useaddCoupons } from "../../../queryHooks/useCoupons";
import { useGetCouponsByID } from "../../../queryHooks/useCoupons";

import moment from "moment";
import { useGetAllRestaurants } from "../../../queryHooks";
import qs from "qs";
// import DateTime from "react-datetime";
//import { useFormik } from "formik";

const Option = (props) => {
	return (
		<div>
			<components.Option {...props}>
				<input
					type="checkbox"
					checked={props.isSelected}
					onChange={() => null}
				/>{" "}
				<label>{props.label}</label>
			</components.Option>
		</div>
	);
};

const selectAllOption = {
	label: "Select all",
	value: "*",
};

//	Component starts
const AddUpdate = ({ coupon, onCloseModal, refetch }) => {
	//	Pre-defined values
	const setLoading = useStore((state) => state.setLoading);

	const featuredOptions = [
		{ value: true, label: "Yes" },
		{ value: false, label: "No" },
	];

	if (isEmpty(coupon))
		coupon = {
			is_featured: { value: true, label: "Yes" },
			is_active: true,
			description: "",
			start_date: new Date(),
			end_date: new Date(),
			code: "",
			tnc: "",
		};

	const [id] = useState(coupon.id);
	const dateFormatUI = "DD-MM-YYYY";
	const timeFormatUI = "h:mm A";

	const statusOptions = [
		{ value: true, label: "Active" },
		{ value: false, label: "InActive" },
	];

	const customStyles = {
		option: (provided, state) => {
			return {
				...provided,
				color: "blue",
				backgroundColor: "white",
			};
		},
	};

	const {
		mutateAsync: updateCoupons,
		error: errorUpdateCoupons,
		data: dataUpdateCoupons,
	} = useupdateCoupons();
	let params = coupon.id;

	const { data: dataCouponById } = useGetCouponsByID(params, {
		enabled: !!params,
	});

	useEffect(() => {
		if (dataUpdateCoupons) {
			setLoading(false);
			if (dataUpdateCoupons.status === "success") {
				onCloseModal();
				CS.showSuccessMessage(dataUpdateCoupons?.message);
				refetch();
			} else if (dataUpdateCoupons.status === "fail") {
				CS.showErrorMessage(dataUpdateCoupons.message);
			}
		}
	}, [dataUpdateCoupons]);

	useEffect(() => {
		if (errorUpdateCoupons) {
			setLoading(false);
			CS.showErrorMessage(errorUpdateCoupons.response?.data?.message);
		}
	}, [errorUpdateCoupons]);

	const {
		mutateAsync: addCoupons,
		error: errorAddCoupons,
		data: dataAddCoupons,
	} = useaddCoupons();

	useEffect(() => {
		if (dataAddCoupons) {
			setLoading(false);
			if (dataAddCoupons.status === "success") {
				onCloseModal();
				CS.showSuccessMessage(dataAddCoupons.message);
				refetch();
			} else if (dataAddCoupons.status === "fail") {
				CS.showErrorMessage(dataAddCoupons.message);
			}
		}
	}, [dataAddCoupons]);

	useEffect(() => {
		if (errorAddCoupons) {
			setLoading(false);
			CS.showErrorMessage(errorAddCoupons.response?.data?.message);
		}
	}, [errorAddCoupons]);

	/********************************************************************************
																GET RESTAURANTS LIST
	 ********************************************************************************/
	const [restaurantOptions, setRestaurantOptions] = useState([]);

	const [restaurantSelectedOptions, setRestaurantSelectedOptions] = useState(
		[]
	);
	let { data: dataGetAllRestaurants } = useGetAllRestaurants(
		qs.stringify({
			pagination: false,
			sort: { "data_restaurants.name": "ASC" },
			filter: {
				admin_approval_status: "APPROVED",
				"data_restaurants.is_active": 1,
			},
		})
	);

	useEffect(() => {
		if (
			dataCouponById &&
			dataCouponById?.data?.restaurants &&
			coupon?.id &&
			dataGetAllRestaurants?.data?.records
		) {
			setDefaultSelectedRestaurants();
		}
	}, [dataCouponById?.data?.restaurants, dataGetAllRestaurants]);

	const setDefaultSelectedRestaurants = () => {
		if (dataGetAllRestaurants) {
			let _restaurants = [];
			for (let i = 0; i < dataCouponById?.data?.restaurants.length; i++) {
				for (let j = 0; j < dataGetAllRestaurants?.data?.records.length; j++) {
					if (
						dataGetAllRestaurants?.data?.records[j].id ==
						dataCouponById?.data?.restaurants[i].id
					) {
						_restaurants.push({
							label: dataGetAllRestaurants?.data?.records[j].name,
							value: dataGetAllRestaurants?.data?.records[j].id,
							isSelected: true,
						});
					}
				}
			}
			if (
				dataCouponById?.data?.restaurants.length ===
				dataGetAllRestaurants?.data?.records.length
			) {
				setRestaurantSelectedOptions([selectAllOption, ..._restaurants]);
			} else setRestaurantSelectedOptions(_restaurants);
		}
	};

	useEffect(() => {
		if (dataGetAllRestaurants && dataGetAllRestaurants.data?.records) {
			let _restaurants = [];
			dataGetAllRestaurants.data.records.forEach((element) => {
				_restaurants.push({
					label: element.name,
					value: element.id,
					isSelected: false,
				});
			});

			setRestaurantOptions(_restaurants);
		}
	}, [dataGetAllRestaurants]);

	// define formData for the Formik

	const [formData, setFormData] = useState({
		tnc: coupon.tnc,
		code: coupon.code,
		description: coupon.description,
		start_date: coupon.start_date,
		end_date: coupon.end_date,
		discount: id
			? Math.trunc(coupon.discount_amount) !== 0
				? Math.trunc(coupon.discount_amount)
				: Math.trunc(coupon.discount_percentage)
			: "",
		restaurants: id ? restaurantSelectedOptions : [],
		max_discount: id ? Math.trunc(coupon.max_discount) : "",
		is_featured:
			coupon.is_featured === 0
				? { value: false, label: "No" }
				: { value: true, label: "Yes" },
		is_active:
			coupon.is_active === 0
				? { value: false, label: "InActive" }
				: { value: true, label: "Active" },
		min_order: id ? Math.trunc(coupon.min_order) : "",
		discountRadioOptions: id
			? Math.trunc(coupon.discount_amount) !== 0
				? "Amount"
				: "Percentage"
			: "Amount",
	});

	useEffect(() => {
		setFormData({
			...formData,
			restaurants: id ? restaurantSelectedOptions : [],
		});
	}, [restaurantSelectedOptions]);

	const { values, errors, handleChange, handleSubmit, touched, setFieldValue } =
		useFormik({
			initialValues: formData,
			enableReinitialize: true,
			validationSchema: couponsSchema,
			onSubmit: (value) => {
				let restaurant_ids = value.restaurants.filter(
					(item) => item.value !== "*"
				);
				restaurant_ids = restaurant_ids.map((itm) => itm.value);
				if (coupon.id) {
					if (value.discountRadioOptions === "Amount") {
						updateCoupons({
							id: coupon.id,
							body: {
								tnc: value.tnc,
								description: value.description,
								start_date: value.start_date,
								end_date: value.end_date,
								discount_amount: value.discount,
								max_discount: value.max_discount,
								is_featured: value.is_featured.value,
								is_active: value.is_active.value,
								min_order: value.min_order,
								restaurant_ids,
							},
						});
						setLoading(true);
					} else {
						updateCoupons({
							id: coupon.id,
							body: {
								tnc: value.tnc,
								description: value.description,
								start_date: value.start_date,
								end_date: value.end_date,
								discount_percentage: value.discount,
								max_discount: value.max_discount,
								is_featured: value.is_featured.value,
								is_active: value.is_active.value,
								min_order: value.min_order,
								restaurant_ids,
							},
						});
						setLoading(true);
					}
				} else {
					if (value.discountRadioOptions === "Amount") {
						addCoupons({
							tnc: value.tnc,
							code: value.code,
							description: value.description,
							start_date: value.start_date,
							end_date: value.end_date,
							discount_amount: value.discount,
							max_discount: value.max_discount,
							is_featured: value.is_featured.value,
							is_active: value.is_active.value,
							min_order: value.min_order,
							restaurant_ids,
						});
						setLoading(true);
					} else {
						addCoupons({
							tnc: value.tnc,
							code: value.code,
							description: value.description,
							start_date: value.start_date,
							end_date: value.end_date,
							discount_percentage: value.discount,
							max_discount: value.max_discount,
							is_featured: value.is_featured.value,
							is_active: value.is_active.value,
							min_order: value.min_order,
							restaurant_ids,
						});
						setLoading(true);
					}
				}
			},
		});

	/***
	 * @description Used to filter data as per the checkbox selected
	 */
	function onChange(value, event) {
		let selectedRestaurants = [];
		if (event.action === "select-option" && event.option.value === "*") {
			selectedRestaurants = Object([
				{ label: "Select All", value: "*" },
				...restaurantOptions,
			]);
		} else if (
			event.action === "deselect-option" &&
			event.option.value === "*"
		) {
			selectedRestaurants = [];
		} else if (event.action === "deselect-option") {
			selectedRestaurants = value.filter((o) => o.value !== "*");
		} else if (event.action === "remove-value") {
			selectedRestaurants = value.filter(
				(o) => o.value !== "*" && o.value !== event.removedValue.value
			);
		} else if (value.length === restaurantOptions.length - 1) {
			selectedRestaurants = Object([
				{ label: "Select All", value: "*" },
				...restaurantOptions,
			]);
		} else {
			selectedRestaurants = value;
		}

		setRestaurantSelectedOptions(selectedRestaurants);

		let event2 = {
			target: { name: "restaurants", value: selectedRestaurants },
		};
		handleChange(event2);
	}

	return (
		<div className="modal-dialog modal-dialog-scrollable m-0 w-100">
			<div className="modal-content">
				<div className="modal-header">
					<h5 className="modal-title">{id ? "Update Coupon" : "Add Coupon"}</h5>
				</div>
				<div className="notification-form modal-body card profile-card password-modal">
					<div className="row">
						<div className="col-md-12">
							<form onSubmit={(e) => handleSubmit(e)}>
								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label">
											Code {!id ? <sup className="text-danger">*</sup> : null}
										</label>
										<div className="w-100 position-relative">
											{id ? (
												<input
													className="form-control"
													type="text"
													id="code"
													name="code"
													readOnly
													style={{ backgroundColor: "lightgray" }}
													value={values.code}
												/>
											) : (
												<input
													className="form-control"
													type="text"
													id="code"
													name="code"
													placeholder="Enter a Code"
													value={values.code}
													onChange={(e) => {
														let event = {
															target: {
																name: "code",
																value: e.target.value.toUpperCase(),
															},
														};
														handleChange(event);
													}}
												/>
											)}

											<div className="error-message-password">
												<span className="text-danger error-msg d-block mb-2">
													{errors.code && touched.code ? errors.code : null}
												</span>
											</div>
										</div>
									</div>
								</div>
								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label">
											Terms and Conditions
											{!id ? <sup className="text-danger">*</sup> : null}
										</label>
										<div className="w-100 position-relative">
											<textarea
												rows="3"
												className="form-control"
												placeholder="Enter a terms and conditions"
												id="tnc"
												name="tnc"
												value={values.tnc}
												onChange={handleChange}
											/>
											<div className="error-message-password">
												<span className="text-danger error-msg d-block mb-2">
													{errors.tnc && touched.tnc ? errors.tnc : null}
												</span>
											</div>
										</div>
									</div>
								</div>

								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label">
											Description
											{!id ? <sup className="text-danger">*</sup> : null}
										</label>
										<div className="w-100 position-relative">
											<textarea
												rows="3"
												className="form-control"
												placeholder="Enter description"
												id="description"
												name="description"
												value={values.description}
												onChange={handleChange}
											/>
											<div className="error-message-password">
												<span className="text-danger error-msg d-block mb-2">
													{errors.description && touched.description
														? errors.description
														: null}
												</span>
											</div>
										</div>
									</div>
								</div>

								<div className="mb-3">
									<label className="label xl-label">
										Start Date and Time
										{!id ? <sup className="text-danger">*</sup> : null}
									</label>
									<Datetime
										className="d-block w-100"
										inputProps={{ placeholder: "Start Date & Time" }}
										onChange={(date) =>
											setFieldValue("start_date", new Date(date))
										}
										value={new Date(values.start_date)}
										closeOnSelect={true}
										dateFormat={dateFormatUI}
										timeFormat={timeFormatUI}
										isValidDate={(current) =>
											current.isAfter(moment().subtract(1, "day"))
										}
									/>
								</div>
								<div className="mb-3">
									<label className="label xl-label">
										End Date and Time
										{!id ? <sup className="text-danger">*</sup> : null}
									</label>
									<Datetime
										className="d-block w-100"
										inputProps={{ placeholder: "End Date & Time" }}
										onChange={(date) =>
											setFieldValue("end_date", new Date(date))
										}
										value={new Date(values.end_date)}
										closeOnSelect={true}
										dateFormat={dateFormatUI}
										timeFormat={timeFormatUI}
										isValidDate={(current) =>
											current.isAfter(
												moment(values.start_date).subtract(1, "day")
											)
										}
									/>
									<div className="error-message-password">
										<span className="text-danger error-msg d-block mb-2">
											{errors.end_date && touched.end_date
												? errors.end_date
												: null}
										</span>
									</div>
								</div>

								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label">
											Discount
											{id
												? Math.trunc(coupon.discount_amount) !== 0
													? "(In Amount)"
													: "(In Percentage)"
												: null}
											{!id ? <sup className="text-danger">*</sup> : null}
										</label>
										<br />
										{!id ? (
											<>
												<div className="form-check form-check-inline">
													<input
														className="form-check-input"
														type="radio"
														name="discountRadioOptions"
														id="Amount"
														value="Amount"
														checked={values.discountRadioOptions === "Amount"}
														onChange={handleChange}
													/>
													<label className="form-check-label" htmlFor="Amount">
														Discount in amount
													</label>
												</div>

												<div className="form-check form-check-inline">
													<input
														className="form-check-input"
														type="radio"
														name="discountRadioOptions"
														id="Percentage"
														value="Percentage"
														onChange={handleChange}
														checked={
															values.discountRadioOptions === "Percentage"
														}
													/>
													<label
														className="form-check-label"
														htmlFor="Percentage"
													>
														Discount in Percentage
													</label>
												</div>
											</>
										) : null}

										<div className="w-100 position-relative mt-2">
											<input
												className="form-control"
												type="text"
												id="discount"
												name="discount"
												placeholder={`${
													values.discountRadioOptions === "Amount"
														? "Enter Discount Amount"
														: "Enter Discount Percentage"
												}`}
												value={values.discount}
												onChange={handleChange}
											/>
											<div className="error-message-password">
												<span className="text-danger error-msg d-block mb-2">
													{errors.discount && touched.discount
														? errors.discount
														: null}
												</span>
											</div>
										</div>
									</div>
								</div>

								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label">
											Max Discount
											{!id ? <sup className="text-danger">*</sup> : null}
										</label>
										<div className="w-100 position-relative">
											<input
												className="form-control"
												type="text"
												id="max_discount"
												name="max_discount"
												placeholder="Enter Max Discount"
												value={values.max_discount}
												onChange={handleChange}
											/>
											<div className="error-message-password">
												<span className="text-danger error-msg d-block mb-2">
													{errors.max_discount && touched.max_discount
														? errors.max_discount
														: null}
												</span>
											</div>
										</div>
									</div>
								</div>
								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label">
											Minimum Order Value
											{!id ? <sup className="text-danger">*</sup> : null}
										</label>
										<div className="w-100 position-relative">
											<input
												className="form-control"
												type="text"
												id="min_order"
												name="min_order"
												placeholder="Enter Min Order Value"
												value={values.min_order}
												onChange={handleChange}
											/>
											<div className="error-message-password">
												<span className="text-danger error-msg d-block mb-2">
													{errors.min_order && touched.min_order
														? errors.min_order
														: null}
												</span>
											</div>
										</div>
									</div>
								</div>
								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label">
											Featured
											{!id ? <sup className="text-danger">*</sup> : null}
										</label>
										<div className="w-100 position-relative">
											<Select
												value={values.is_featured}
												onChange={(option) =>
													setFieldValue("is_featured", option)
												}
												options={featuredOptions}
											/>
										</div>
									</div>
								</div>
								{id && (
									<div className="mb-md-4 mb-3">
										<div className="form-group mb-0">
											<label className="label xl-label">
												Status
												{!id ? <sup className="text-danger">*</sup> : null}
											</label>
											<div className="w-100 position-relative">
												<Select
													value={values.is_active}
													onChange={(option) =>
														setFieldValue("is_active", option)
													}
													options={statusOptions}
												/>
											</div>
										</div>
									</div>
								)}
								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label">Restaurants</label>
										<div className="w-100 position-relative">
											<MultiSelect
												value={restaurantSelectedOptions}
												isMulti
												// isClearable
												closeMenuOnSelect={false}
												hideSelectedOptions={false}
												styles={customStyles}
												// allowSelectAll={true}
												onChange={onChange}
												components={{
													Option,
												}}
												options={[selectAllOption, ...restaurantOptions]}
											/>
											<div className="error-message-password">
												<span className="text-danger error-msg d-block mb-2">
													{errors.restaurants && touched.restaurants
														? errors.restaurants
														: null}
												</span>
											</div>
										</div>
									</div>
								</div>
								<div className="mt-5 text-right">
									<button className="btn btn-primary" type="submit">
										{id ? "Update" : "Add"}
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

/******************************************************************************************
@Purpose    :   To validate the props
*******************************************************************************************/
PropTypes.propTypes = {
	coupon: PropTypes.object,
	columnKey: PropTypes.string.isRequired,
	onCloseModal: PropTypes.func.isRequired,
};

export default memo(AddUpdate);
